<textarea  [cols]="cols" rows="10"  [class]="inputClass" [ngClass]="{'input-has-error':inputFormControl.touched && inputFormControl.errors}"
 placeholder="{{placeholder}}" [formControl]="inputFormControl"></textarea>
 <div class="has-error" *ngIf="inputFormControl.touched  && inputFormControl.errors?.required">
    {{displayName}} is required.
</div>